import { destroyCookie, parseCookies, setCookie } from "nookies";
import { COOKIES_FIELDS } from "../constants";
import { getTokenExpiresDuration } from "../utils/auth";

const cookiesService = (function() {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _setLoginData(res) {
    setCookie(null, COOKIES_FIELDS.accessToken, res.token?.access, {
      path: "/",
      maxAge: getTokenExpiresDuration(res.token?.access)
    });
    setCookie(null, COOKIES_FIELDS.refreshToken, res.token?.refresh, {
      path: "/",
      maxAge: getTokenExpiresDuration(res.token?.refresh)
    });
    setCookie(null, COOKIES_FIELDS.userData, JSON.stringify(res.user), {
      path: "/",
      maxAge: getTokenExpiresDuration(res.token?.access)
    });
  }
  function _setAccessToken(token) {
    try {
      setCookie(null, COOKIES_FIELDS.accessToken, token, {
        path: "/",
        maxAge: getTokenExpiresDuration(token)
      });
    } catch (e) {}
  }
  function _getAccessToken(ctx) {
    try {
      const cookies = parseCookies(ctx || null);
      return cookies[COOKIES_FIELDS.accessToken];
    } catch (e) {
      return "";
    }
  }
  function _getRefreshToken(ctx) {
    try {
      const cookies = parseCookies(ctx || null);
      return cookies[COOKIES_FIELDS.refreshToken];
    } catch (e) {
      return "";
    }
  }
  function _getUserData(ctx) {
    try {
      const cookies = parseCookies(ctx || null);
      const userData = cookies[COOKIES_FIELDS.userData];
      if (!userData) return {};
      return JSON.parse(userData);
    } catch (e) {
      return {};
    }
  }
  function _isCredentialsExist(ctx) {
    return !!_getAccessToken(ctx) && !!_getRefreshToken(ctx);
  }
  function _clearToken() {
    destroyCookie(null, COOKIES_FIELDS.accessToken);
    destroyCookie(null, COOKIES_FIELDS.refreshToken);
    destroyCookie(null, COOKIES_FIELDS.userData);
  }
  return {
    setAccessToken: _setAccessToken,
    getService: _getService,
    setLoginData: _setLoginData,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    getUserData: _getUserData,
    clearToken: _clearToken,
    isCredentialsExist: _isCredentialsExist
  };
})();

export default cookiesService;
